import React, { Component } from 'react';
import PaymentConfigHandler from '/app/src/config/PaymentConfigHandler'

export default function withPaymentPermission(service) {
    return (WrappedComponent) => {
        return class HOC extends Component {
            render() {
                const shouldDisplay = PaymentConfigHandler.checkAccess(service, 'read') !== 0
                return shouldDisplay ? <WrappedComponent {...this.props} /> : null
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/hoc/withPaymentPermission.js